/* eslint-disable class-methods-use-this */
import { Component } from 'react';
import { Navigate } from 'react-router-dom';
import AdminLoginForm from '../../../common/login/login-form';
import ImpersonationNotice from '../../../common/login/impersonation-notice';
import { isAuditorLoggedIn } from '../../../../utils/tokenUtils';
import { isAdminLoggedIn } from '../../../../utils/sessionAreas';
import { adminLogin } from '../../../../actions/login';

import './login.css';

export default class AdminLogin extends Component {
  render() {
    if (isAdminLoggedIn()) {
      const path = isAuditorLoggedIn() ? '/admin/audit/submissions' : '/admin/my-profile';

      return <Navigate to={path} replace />;
    }

    return (
      <div className="row">
        <div className="col-md-5 col-md-offset-1">
          <ImpersonationNotice />
          <AdminLoginForm type={this.props.area} loginAction={adminLogin}/>
        </div>
      </div>
    );
  }
}
